import {Stack} from '@mui/material';
import React, {Fragment, PropsWithChildren, Suspense} from 'react';
import {Helmet} from 'react-helmet-async';
import {Outlet} from 'react-router-dom';

import {useHandleNewAppointment} from 'presentation/pages';
import {Overbooking} from 'presentation/pages/private/booking/components';

import {ConfirmationDrawer} from 'presentation/pages/private/booking/components/ConfirmationDrawer';
import {useOverbookingModalStore} from 'presentation/pages/private/booking/components/Overbooking/store';
import {AppointmentTypeSelect} from 'presentation/modules/myAppointments/ui/components/AppointmentTypeSelect';
import {translations} from 'presentation/translations-new';
import {Loading} from '../Loading/Loading';
import {PageWrapperLayoutProps} from './types';
import {VoiceTranscriptionDrawer} from '../VoiceTranscriptionDrawer';
import {useOpenOptionsDrawerStore} from 'presentation/pages/private/store/useOpenOptionsDrawer';
import {OptionsDrawer} from 'presentation/pages/private/home/components/OptionsDrawer';
import {SaludiaDrawers} from '../SaludiaDrawers';
import {AdvanceDiagnosticsBooking} from 'presentation/pages/private/home/components/AdvanceDiagnosticsBooking';

const {loading} = translations['pt-br'].commons;

export function PageWrapperContent() {
	return (
		<Suspense fallback={<Loading text={loading} minHeight="100%" />}>
			<Outlet />
		</Suspense>
	);
}

export function PageWrapperLayout({title, children}: PropsWithChildren<PageWrapperLayoutProps>) {
	const {appointmentModalOpen, setAppointmentModalOpen} = useHandleNewAppointment();
	const overbookingModalOpen = useOverbookingModalStore(state => state.overbookingModalOpen);
	const setOverbookingModalOpen = useOverbookingModalStore(
		state => state.setOverbookingModalOpen,
	);
	const {isOptionsDrawerOpen, optionsDrawerTitle, optionsDrawerItems, closeOptionsDrawer} =
		useOpenOptionsDrawerStore();

	return (
		<Fragment>
			<Helmet>
				<title>{title}</title>
			</Helmet>
			<Stack flex={1}>
				{children}
				<PageWrapperContent />
			</Stack>
			<AppointmentTypeSelect
				open={appointmentModalOpen}
				onClose={() => setAppointmentModalOpen(false)}
				onOpen={() => setAppointmentModalOpen(true)}
			/>
			<Overbooking open={overbookingModalOpen} setOpen={setOverbookingModalOpen} />
			<ConfirmationDrawer />

			<VoiceTranscriptionDrawer />
			<OptionsDrawer
				isOpen={isOptionsDrawerOpen}
				onClose={closeOptionsDrawer}
				items={optionsDrawerItems}
				title={optionsDrawerTitle}
			/>
			<SaludiaDrawers />
			<AdvanceDiagnosticsBooking />
		</Fragment>
	);
}
